<template>
  <button :disabled="is_loading" @click="onClick" class="widget_button">
    <loading
      :height="15"
      color="#fff"
      :opacity="1"
      :width="15"
      :active.sync="is_loading"
      :is-full-page="false"
      :can-cancel="false"
      background-color="#0065E1"
      class="loader"
    ></loading>
    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "widget_button",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      is_loading: true,
    };
  },
  watch: {
    loading: function (val) {
      this.is_loading = val;
    },
  },
  mounted() {
    let vm = this;
    vm.is_loading = vm.loading;
  },
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget_button {
  padding: 12px 10px;
  border-radius: 5px;
  border: none;
  font-style: bold !important;
  font-weight: 500;
  width: 100%;
  position: relative;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &.outline {
    background: #fff;
    border-width: 1px;
    border-style: solid;
  }
  &.transparent {
    background: transparent;
    border-style: none;
  }
  .loader {
    border-radius: 5px;
  }
}
</style>
